(function() {
  var btn = document.getElementById("RecipePdfBtn");
  if (!btn) return;

  btn.addEventListener("click", function() {
    var titleEl = document.querySelector(".recipe-title");
    var welshEl = document.querySelector(".recipe-title-welsh");
    var heroImg = document.querySelector(".recipe-hero-image img");
    var metaItems = document.querySelectorAll(".recipe-meta-item");
    var notesEl = document.querySelector(".recipe-notes-content");
    var ingredientEls = document.querySelectorAll(".recipe-ingredients li");
    var stepEls = document.querySelectorAll(".recipe-method li");

    var titleText = titleEl ? titleEl.textContent.trim() : "Recipe";
    var heroSrc = heroImg ? heroImg.src : "";
    var welshText = welshEl ? welshEl.textContent.trim() : "";

    var metaHtml = "";
    metaItems.forEach(function(item) {
      var span = item.querySelector("span");
      if (span) metaHtml += "<span>" + span.textContent.trim() + "</span> ";
    });

    var notesHtml = "";
    if (notesEl && notesEl.textContent.trim()) {
      notesHtml = notesEl.innerHTML;
    }

    var ingredientsHtml = "";
    ingredientEls.forEach(function(li) {
      if (li.classList.contains("recipe-ingredient-heading")) {
        ingredientsHtml += "<li class='heading'>" + li.textContent.trim() + "</li>";
      } else {
        ingredientsHtml += "<li>" + li.textContent.trim() + "</li>";
      }
    });

    var methodHtml = "";
    stepEls.forEach(function(li) {
      methodHtml += "<li>" + li.textContent.trim() + "</li>";
    });

    var w = window.open("", "_blank");
    w.document.open();
    w.document.write("<!DOCTYPE html><html><head><meta charset='utf-8'>");
    w.document.write("<title>" + titleText + "</title>");
    w.document.write("<style>");
    w.document.write("body{font-family:Georgia,'Times New Roman',serif;color:#122e5c;max-width:700px;margin:0 auto;padding:30px;line-height:1.6}");
    w.document.write(".header{text-align:center;margin-bottom:20px;padding-bottom:14px;border-bottom:2px solid #122e5c}");
    w.document.write(".header img{max-width:100%;max-height:220px;object-fit:cover;border-radius:6px;margin-bottom:12px}");
    w.document.write(".header h1{font-size:26px;margin:0 0 4px}");
    w.document.write(".welsh{font-style:italic;color:#666;margin:0 0 10px;font-size:16px}");
    w.document.write(".meta{display:flex;justify-content:center;gap:16px;font-size:13px;color:#555;flex-wrap:wrap}");
    w.document.write(".section{margin-bottom:18px}");
    w.document.write(".section h2{font-size:18px;border-bottom:1px solid #122e5c;padding-bottom:4px;margin:0 0 10px}");
    w.document.write("ul{padding-left:20px}ol{padding-left:24px}");
    w.document.write("li{margin-bottom:6px;font-size:14px;line-height:1.6}ol li{padding-left:8px}");
    w.document.write("ul li.heading{list-style:none;margin:12px 0 4px -20px;font-weight:bold;font-size:15px}ul li.heading:first-child{margin-top:0}");
    w.document.write(".notes{font-size:14px;line-height:1.6}.notes p{margin:0 0 8px}");
    w.document.write(".footer{margin-top:24px;padding-top:10px;border-top:1px solid #ccc;font-size:11px;color:#999;text-align:center}");
    w.document.write("@media print{body{padding:15px}.header img{max-height:180px}}");
    w.document.write("</style></head><body>");

    w.document.write("<div class='header'>");
    if (heroSrc) w.document.write("<img src='" + heroSrc + "' alt=''>");
    w.document.write("<h1>" + titleText + "</h1>");
    if (welshText) w.document.write("<p class='welsh'>" + welshText + "</p>");
    if (metaHtml) w.document.write("<div class='meta'>" + metaHtml + "</div>");
    w.document.write("</div>");

    if (notesHtml) {
      w.document.write("<div class='section'><h2>Notes</h2><div class='notes'>" + notesHtml + "</div></div>");
    }
    if (ingredientsHtml) {
      w.document.write("<div class='section'><h2>Ingredients</h2><ul>" + ingredientsHtml + "</ul></div>");
    }
    if (methodHtml) {
      w.document.write("<div class='section'><h2>Method</h2><ol>" + methodHtml + "</ol></div>");
    }

    w.document.write("<div class='footer'>Recipe from Halen M&ocirc;n &mdash; halenmon.com</div>");
    w.document.write("</body></html>");
    w.document.close();

    setTimeout(function() {
      w.focus();
      w.print();
    }, 500);
  });
})();
